'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.ticker = twentyninetimes.ticker || function () {

	function init() {
		var tickers = document.querySelectorAll('.js-ticker');
		if (tickers) {
			tickers.forEach(ticker => {
				var list_amount = ticker.hasAttribute('data-ticker-lists')
					? ticker.getAttribute('data-ticker-lists') - 1
					: 1,
					ticker_list = ticker.children[0];

				for (let i = 0; i < list_amount; i++) {
					var clone = ticker_list.cloneNode(true);

					ticker.append(clone);
				}
			});
		}
	}

	return {
		init: init
	};

}();